import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { ProductResponse, TransformationProduct, TransformationProductItem } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductService } from 'src/app/services/product.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { InvoiceSaleService } from '../invoice-sale/invoice-sale.service';
import { ConfigurationInvoice, InvoiceItemModel, InvoiceTemplateModel } from 'src/app/models/invoice-template.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { TemplateInvoice } from 'src/app/templateInvoice/templateInvoice';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { PermsUtil } from 'src/app/common/util';
import { RecipeService } from 'src/app/services/recipe.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { co, ex } from '@fullcalendar/core/internal-common';

@Component({
  selector: 'app-transfer-products',
  templateUrl: './transfer-products.component.html',
  styleUrls: ['./transfer-products.component.scss']
})
export class TransferProductsComponent implements OnInit {

  warehouses = [];
  filteredWarehouses = [];
  inputs = {};
  timeout = null;
  products = [];
  listProducts = [];
  newTransfer = new TransformationProduct();
  expectedDate = "";
  issuedDate = "";
  loading = false;
  toProducts = [];
  carrier = new InputAutocompleteModel("", false, false, "Ingresa un nit o cui", "fa-list", "", "", null, []);
  allClients = [];
  searchingCarrier = false;
  company = null;
  permissionType = PermissionTypeEnum;
  authorizated = true;
  type = 0;
  user = null;
  prescribe = false;
  productCosts: { [key: number]: number } = {};

  constructor(
    private warehouseService: WarehouseService,
    private toastService: ToastrService,
    private productService: ProductService,
    private inventoryService: InventoryService,
    private recipeService: RecipeService,
    private service: InvoiceSaleService,
    private createService: TemplateInvoice,
    private authService: AuthenticationService
  ) {
    this.user = authService.getUser();
    this.company = JSON.parse(authService.getCurrentCompany());

  }

  getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Los meses comienzan desde 0
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  ngOnInit(): void {
    this.start();
  }

  start() {
    this.newTransfer = new TransformationProduct();
    this.verifiedPerms();
    this.issuedDate = this.getTodayDate();
    this.expectedDate = this.getTodayDate();
    this.listProducts = [];
    this.toProducts = [];
    this.getWarehouses();
    this.getProducts();
    this.getClients();
  }

  verifiedPerms() {
    var perms = this.authService.getPermissions(); 
    if (perms) {
      if (PermsUtil.hasPerm(perms, 2043)) {
        this.newTransfer.transformation = false;
      } else {
        if (PermsUtil.hasPerm(perms, 2049)) {
          this.newTransfer.transformation = true;
        } else {
          this.authorizated = false;
        }
      }
    } else {
      this.authorizated = true;
    }
  }

  getClients() {
    this.service.getClients().subscribe({
      next: (response: ResponseObject) => {
        this.carrier.filterElements = response.data;
        this.allClients = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.success);
      }
    })
  }

  writeClient() {
    clearTimeout(this.timeout);
    this.carrier.verified = false;
    this.carrier.data = null;
    this.carrier.class = "typing";
    this.timeout = setTimeout(() => {
      var searched = this.carrier.value.toLowerCase();
      this.carrier.filterElements = this.allClients.filter((c) => {
        return c.nit?.toLowerCase().includes(searched) || c.name.toLowerCase().includes(searched)
      });
      if (this.carrier.filterElements.length == 0) {
        this.carrier.class = "loading";
        this.searchingCarrier = true;
        this.service.getClientsByNit(searched).subscribe({
          next: (response: ResponseObject) => {
            this.searchingCarrier = false;
            if (response) {
              this.allClients.push(response.data);
              this.carrier.class = "fa-list";
              this.selectCarrier(response.data);
            } else {
              this.toastService.info("El nit/cui no es valido");
              this.carrier.message = "El nit/cui no es valido";
              this.carrier.class = "fa-xmark";
            }
          },
          error: (error: HttpErrorResponse) => {
            this.searchingCarrier = false;
            this.carrier.class = "fa-xmark";
            this.carrier.message = "Error al contactar al servidor";
            this.toastService.error(error.error.message);
          }
        });
      } else {
        this.carrier.class = "fa-list";
        this.carrier.data = null;
        this.carrier.message = "Elige un resultado";
      }
    }, 500);
  }

  selectCarrier(carrier) {
    this.carrier.value = carrier.nit + ' ' + carrier.name;
    this.carrier.class = "fa-circle-check";
    this.carrier.data = carrier;
    this.carrier.message = "Transportista seleccionado";
    this.carrier.verified = true;
  }

  getProducts() {
    this.productService.getProducts('').subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data;
        this.products = this.products.filter((p) => {
          return p.type != "s"
        })
        this.inputs['product'] = { value: null, verified: false, required: false, class: 'fa-list', data: null, filterElements: this.products, bgColor: "" };
        this.inputs['toTransfer'] = { value: null, verified: false, required: false, class: 'fa-list', data: null, filterElements: this.products, bgColor: "" };
        this.inputs['result'] = { value: null, verified: false, required: false, class: 'fa-list', data: null, filterElements: this.products, bgColor: "" };
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.success);
      }
    })
  }

  getWarehouses() {
    this.warehouseService.getWarehouseByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.getWarehousesByUser();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.success);
      }
    })
  }

  manageInputs(){
    let warehouses = JSON.parse(JSON.stringify(this.warehouses));
    let filtered = JSON.parse(JSON.stringify(this.filteredWarehouses));
    this.inputs['from'] = { value: null, verified: false, required: true, class: 'fa fa-asterisk', data: null, total: filtered, filterElements: filtered, bgColor: "" };
    this.inputs['to'] = { value: null, verified: false, required: true, class: 'fa fa-asterisk', data: null, total: warehouses, filterElements: warehouses, bgColor: "" };
    if (filtered.length == 1) {
      this.selectWarehouse(filtered[0], this.inputs['from'], this.inputs['to']);
    }
  }

  getWarehousesByUser() {
    this.warehouseService.getWarehousesAllowedByUser(this.user.id).subscribe({
      next: (response: ResponseObject) => {
        this.filteredWarehouses = response.data;
        this.manageInputs();
      },
      error: (error) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  writeWarehouse(inputValue: string, input: any, otherInput: any) {
    input.class = "typing";
    input.filterElements = input.total.filter((w) => {
      return w.id == inputValue || w.name.toLowerCase().includes(inputValue.toLowerCase()) || w.nit == inputValue
    });
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (input.filterElements.length == 1) {
        this.selectWarehouse(input.filterElements[0], input, otherInput);
      } else {
        input.class = (input.filterElements.length == 0) ? "fa fa-xmark" : "fa fa-list";
        input.verified = false;
        input.data = null;
      }
    }, 1000);
  }

  selectWarehouse(warehouse: any, input: any, otherInput: any) {
    clearTimeout(this.timeout);
    input.value = warehouse.name;
    input.class = "fa fa-circle-check";
    input.verified = true;
    input.data = warehouse;
    otherInput.filterElements = otherInput.total.filter((w) => {
      return w.id != warehouse.id;
    })
  }

  writeProduct(inputValue: string, input: any, isResult: boolean) {
    input.class = "typing";
    input.filterElements = this.products.filter((w: ProductResponse) => {
      var lowcase = inputValue ? inputValue.toLowerCase() : "";
      return w.id+"" == inputValue || w.name.toLowerCase().includes(lowcase) || w.code.toLowerCase().includes(lowcase)
        || w.barCode?.toLowerCase().includes(lowcase);
    });
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (input.filterElements.length == 1) {
        // this.selectProduct(input.filterElements[0], input, isResult);
      } else {
        input.class = (input.filterElements.length == 0) ? "fa fa-xmark" : "fa fa-list";
        input.verified = false;
        input.data = null;
      }
    }, 1000);
  }

  selectProduct(product: any, input: any, isResult: boolean) {
    clearTimeout(this.timeout);
    //input.value = product.title;
    input.verified = false;
    input.data = null;
    if (!isResult) {
      input.class = "loading";
      this.productService.getExistence(this.inputs['from'].data.id, product.id).subscribe(
        {
          next: (response: ResponseObject) => {
            input.class = "fa-list";
            if (response.data > 0 || this.prescribe) {
              this.listProducts.push({ product: product, id: product.id, name: product.name, quantity: 1, existence: response.data, costPercentage: 0, cost: 0 })
            } else {
              this.toastService.info("El producto " + product.name + " no cuenta con existencias en la bodega");
            }
            this.culculateCost();
          },
          error: (error: HttpErrorResponse) => {
            input.class = "fa-xmark";
            this.toastService.error(error.error.success);
          }
        }
      )
    } else {
      //Obtener si es o no un producto con receta
      this.recipeService.getRecipeById(product.id).subscribe({
        next: (response: ResponseObject) => {
          if (response && response.data.listIngredients.length > 0) {
            this.toastService.error(`El producto ${product.name} ya tiene una receta.`)
          } else {
            this.toProducts.push({ product: product, id: product.id, name: product.name, quantity: 1, existence: null, costPercentage: 0 })
          }
        },
        error: (error: HttpErrorResponse) => {
          console.log(error); 
        }
      });
    }
  }

  transferProducts() {
    const now = new Date();
    // console.log(new Date(new Date(this.expectedDate).getTime() + 6 * 60 * 60 * 1000).getTime());
    // console.log(new Date(new Date(this.issuedDate).setUTCHours(0, 0, 0, 0)).getTime());
    // console.log(new Date(new Date(this.issuedDate).getTime() + 30 * 60 * 60 * 1000).getTime());
    const issued = new Date(new Date(this.issuedDate).getTime() + 6 * 60 * 60 * 1000);
    const expected = new Date(new Date(this.expectedDate).getTime() + 6 * 60 * 60 * 1000);
    issued.setHours(
      now.getHours(),
      now.getMinutes(),
      now.getSeconds(),
      now.getMilliseconds()
    );
    expected.setHours(
      now.getHours(),
      now.getMinutes(),
      now.getSeconds(),
      now.getMilliseconds()
    );
    
    //this.newTransfer.expectedDate = new Date(new Date(this.expectedDate).getTime() + 6 * 60 * 60 * 1000).getTime();
    this.newTransfer.fromProducts = [];
    this.newTransfer.toProducts = [];
    this.newTransfer.expectedDate = expected.getTime();
    let isExistZero = false;
    this.listProducts.forEach((p) => {
      if(p.quantity<=0) { isExistZero = true;}
    })
    if (isExistZero) {
      this.toastService.warning("Existe un producto con cantidad 0 o menor a 0");
      return;
    }

    this.listProducts.forEach((p) => {
      const temp = new TransformationProductItem();
      temp.costPercentage = p.costPercentage;
      temp.existence = p.existence;
      temp.productId = p.id;
      temp.productName = p.name;
      temp.quantity = p.quantity;
      this.newTransfer.fromProducts.push(temp);
    })
    this.newTransfer.description
    this.newTransfer.fromWarehouse = this.inputs['from'].data.id;
    this.newTransfer.fromWarehouseName = this.inputs['from'].data.name;
//    this.newTransfer.issuedDate = new Date(new Date(this.issuedDate).setUTCHours(0, 0, 0, 0)).getTime();
    this.newTransfer.issuedDate = issued.getTime();
    if (!this.newTransfer.transformation) {
      this.newTransfer.toWarehouse = this.inputs['to'].data.id;
      this.newTransfer.toWarehouseName = this.inputs['to'].data.name;
    } else {
      this.newTransfer.toWarehouse = this.inputs['from'].data.id;
      this.newTransfer.toWarehouseName = this.inputs['from'].data.name;
      this.toProducts.forEach((p) => {
        const temp = new TransformationProductItem();
        temp.costPercentage = p.costPercentage;
        temp.existence = p.existence;
        temp.productId = p.id;
        temp.productName = p.name;
        temp.quantity = p.quantity;
        this.newTransfer.toProducts.push(temp);
      })
    }
    // this.loading = true;
    if (this.carrier.data) {
      this.newTransfer.carrier = this.carrier.data.id;
    }
    if ((!this.carrier.data && this.newTransfer.plate) || (this.carrier.data && !this.newTransfer.plate)) {
      return;
    }
    var origin = this.inputs['from'].data;
    var destination = this.inputs['to'].data;
    var carrier = this.carrier.data;
    var invoiceData: any = {};
    if (!this.newTransfer.transformation) {
      invoiceData.carrier = carrier ? carrier.name : '';
      invoiceData.nitCarrier = carrier ? carrier.nit : '';
      invoiceData.plate = this.newTransfer.plate;
      invoiceData.dateTransfer = this.issuedDate;
      invoiceData.destination = destination.name;
    }
    invoiceData.items = [];
    this.listProducts.forEach((p) => {
      invoiceData.items.push({ code: p.product.code, description: p.name, quantity: p.quantity })
    });
    
    if (this.loading) return;

    this.loading = true;
    this.productService.transferProductValidation(this.newTransfer).subscribe({
      next: (response: ResponseObject) => {
        this.productService.transferProduct(this.newTransfer).subscribe({
          next: (response: ResponseObject) => {
            invoiceData.number = response.data.split("-")[1];
            invoiceData.series = response.data.split("-")[0];
            var inv = this.createInvoiceFromData(invoiceData, origin);
            this.createInvoicePDF(inv);
            this.toastService.success("Transferencia realizada con exito");
            this.loading = false;
            this.start();
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error("No tiene existencias para la transacción en la fecha seleccionada,  tiene compras con fechas posteriores a la operación", "Error al realizar la transacción");
            this.loading = false;
          }
        });
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("La bodega hacia donde se quiere transferir no tiene destino asignado.", "Error al realizar la transacción");
        this.loading = false;
      }
    });
    
  }

  createInvoiceFromData(invoiceData: any, warehouse): InvoiceTemplateModel {
    var templateGenerated = new InvoiceTemplateModel();
    templateGenerated.warehouse = warehouse;
    templateGenerated.type = InvoiceType.TRANSFER;
    templateGenerated.invoice.date = (invoiceData.date) ? new Date(invoiceData.date).toLocaleDateString('en-CA') : "";
    templateGenerated.invoice.number = (invoiceData.number) ? invoiceData.number : "";
    templateGenerated.invoice.serial = (invoiceData.series) ? invoiceData.series : "";
    templateGenerated.carrier.name = invoiceData.carrier;
    templateGenerated.carrier.nit = invoiceData.nitCarrier;
    templateGenerated.carrier.destination = invoiceData.destination;
    templateGenerated.carrier.date = invoiceData.dateTransfer;
    templateGenerated.carrier.plate = invoiceData.plate;
    templateGenerated.seller.name = this.company.companyName;
    templateGenerated.seller.city = "";
    templateGenerated.seller.nit = templateGenerated.warehouse.nit ? templateGenerated.warehouse.nit :
      (this.company.companyNIT ? this.company.companyNIT : "");
    templateGenerated.seller.state = '';
    templateGenerated.seller.street = "";
    invoiceData.items.forEach(bd => {
      var toAdd = new InvoiceItemModel(bd.quantity, 0, bd.description);
      toAdd.code = bd.code;
      templateGenerated.items.push(toAdd);
    });
    return templateGenerated;
  }

  async createInvoicePDF(invoiceData: InvoiceTemplateModel) {
    var selected = invoiceData.warehouse as WarehouseResponse;
    var template = selected.nfact < 1 && selected.nfact > 7 ? 1 : selected.nfact;
    var configurationInvoice = new ConfigurationInvoice(template, selected.fcolor, selected.scolor, selected.tcolor, selected.slogan);
    if (selected.logo) {
      this.createService.selectTemplate(configurationInvoice, invoiceData, selected.logo);
    } else {
      if (this.company) {
        if (!this.company.companyLogo.includes("/images/company-avatar2.png")) {
          this.createService.selectTemplate(configurationInvoice, invoiceData, this.company.companyLogo);
        } else {
          this.createService.selectTemplate(configurationInvoice, invoiceData, null);
        }
      } else {
        this.createService.selectTemplate(configurationInvoice, invoiceData, null);
      }
    }
  }

  deleteProductFromList(index: number, isResult: boolean) {
    if (isResult) {
      this.toProducts.splice(index, 1);
    } else {
      this.listProducts.splice(index, 1);
    }
  }

  deleteProductFromListByTransfer(index: number) {
    this.toProducts.splice(index, 1);
    this.listProducts.splice(index, 1);
  }

  verifiedPercentage() {
    var total = 0;
    this.toProducts.forEach((p) => {
      total += p.costPercentage;
    })

    return total == 100;
  }

  culculateCost() {
    this.listProducts.forEach(product => {
      this.inventoryService.getLastProduct(product.id).subscribe({
        next: (response: ResponseObject) => {
          if (!response || response.data === null) {
            this.productCosts[product.id] = 0;
            product.cost = 0;
            return;
          }
          const cost = response.data.cost as number;
          this.productCosts[product.id] = cost*product.quantity;
          product.cost = cost;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(`Error al obtener el costo del producto: ${product.name}`, "Error");
        }
      });
    });
  }

  get totalcost() {
    let total = 0;
    this.listProducts.forEach(product => {
      const cost = product.cost || 0;
      total += cost * product.quantity;
    });
    return total.toFixed(2);
  }
}
